import {
  Action,
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
  StoreCreator,
} from 'redux';
import { Navigation } from '../modules/navigation';
import { withExtraArgument } from 'redux-thunk';
import rootReducer, { AppState } from './reducers';
import trackingMiddleware from '../middlewares/tracking-middleware';
import hydrationMiddleware from '../middlewares/hydration-middleware';
import routerMiddleware from '../middlewares/router-middleware';
import { getWindow } from '../modules/helpers';
import { AppStore, CallAsync } from '../definitions/types';

async function defaultCallAsync(fn: Function, ...args: {}[]): Promise<{}> {
  return await fn(...args);
}

export default function configureStore(
  initialState: AppState = {} as AppState,
  navigation: Navigation
): AppStore {
  const thunkMiddleware = withExtraArgument<AppState, Action, CallAsync>(defaultCallAsync);

  const middlewaresEnhancer = applyMiddleware(
    thunkMiddleware,
    hydrationMiddleware,
    routerMiddleware(navigation),
    trackingMiddleware
  );
  const window = getWindow();
  const devToolsExtension = window?.devToolsExtension;
  const devToolsEnhancer = devToolsExtension
    ? devToolsExtension()
    : (f: StoreCreator) => f;
  const enhancer = compose(middlewaresEnhancer, devToolsEnhancer);
  const store = createStore(rootReducer, initialState, enhancer);

  return store;
}
